import {
  GET_SERVICES_SUCCESS,
  GET_SERVICES_FAIL,
  GET_SERVICES,
  POST_RESEND_SERVICE_EMAIL_VERIFICATION,
  POST_RESEND_SERVICE_EMAIL_VERIFICATION_SUCCESS,
  POST_RESEND_SERVICE_EMAIL_VERIFICATION_FAIL,
  POST_SERVICE,
  POST_SERVICE_FAIL,
  POST_SERVICE_SUCCESS,
  GET_REDIRECT_SLACK,
  GET_REDIRECT_SLACK_SUCCESS,
  GET_REDIRECT_SLACK_FAIL,
  GET_NOTIFICATION_CHANNEL,
  GET_NOTIFICATION_CHANNEL_SUCCESS,
  GET_NOTIFICATION_CHANNEL_FAIL,
  GET_PAGERDUTY_SERVICES,
  GET_PAGERDUTY_SERVICES_SUCCESS,
  GET_PAGERDUTY_SERVICES_FAIL,
  GET_OPSGENIE_SERVICES,
  GET_OPSGENIE_SERVICES_SUCCESS,
  GET_OPSGENIE_SERVICES_FAIL,
  POST_UPDATE_SERVICE,
  POST_UPDATE_SERVICE_SUCCESS,
  POST_UPDATE_SERVICE_FAIL,
  GET_SPECIFIC_SERVICES_SUCCESS,
  GET_SPECIFIC_SERVICES_FAIL,
  GET_SPECIFIC_SERVICES,
  GET_INTEGRATION_KEYS,
  GET_INTEGRATION_KEYS_SUCCESS,
  GET_INTEGRATION_KEYS_FAIL,
  POST_CREATE_INTEGRATION_KEY,
  POST_CREATE_INTEGRATION_KEY_SUCCESS,
  POST_CREATE_INTEGRATION_KEY_FAIL,
  RESET_INTEGRATION_URL,
  GET_INTEGRATION_ACTION_URL_SUCCESS,
  GET_INTEGRATION_ACTION_URL_FAIL,
  GET_INTEGRATION_ACTION_URL,
  POST_TEST_NOTIFICATION, POST_TEST_NOTIFICATION_SUCCESS, POST_TEST_NOTIFICATION_FAIL,
  GET_MASTER_BLUEJAY_COMMUNICATION_CHANNEL_SUCCESS, GET_MASTER_BLUEJAY_COMMUNICATION_CHANNEL, GET_MASTER_BLUEJAY_COMMUNICATION_CHANNEL_FAIL,
  GET_BLUEJAY_COMMUNICATION_CHANNEL_BY_SERVICE_ID,GET_BLUEJAY_COMMUNICATION_CHANNEL_BY_SERVICE_ID_SUCCESS,GET_BLUEJAY_COMMUNICATION_CHANNEL_BY_SERVICE_ID_FAIL,
  POST_UPDATE_BLUEJAY_COMMUNICATION_CHANNEL_BY_ID_SUCCESS,POST_UPDATE_BLUEJAY_COMMUNICATION_CHANNEL_BY_ID,POST_UPDATE_BLUEJAY_COMMUNICATION_CHANNEL_BY_ID_FAIL,
  CREATE_UPDATE_TAG,
  CREATE_UPDATE_TAG_SUCCESS,
  CREATE_UPDATE_TAG_FAIL,
  GET_TAG_VALUES,
  GET_TAG_VALUES_SUCCESS,
  GET_TAG_VALUES_FAIL,
  DELETE_TAG_VALUE,
  DELETE_TAG_VALUE_SUCCESS,
  DELETE_TAG_VALUE_FAIL,
  GET_ALL_KEY_NAMES,
  GET_ALL_KEY_NAMES_SUCCESS,
  GET_ALL_KEY_NAMES_FAIL,
  SET_MAINTENANCE_WINDOW_BY_ID,
  SET_MAINTENANCE_WINDOW_BY_ID_SUCCESS,
  SET_MAINTENANCE_WINDOW_BY_ID_FAIL
} from "./actionTypes";

// services data

export const getServices = () => ({
  type: GET_SERVICES,
})

export const postResendEmail = data => ({
  type: POST_RESEND_SERVICE_EMAIL_VERIFICATION,
  payload: data,
})

export const getServicesSuccess = services => ({
  type: GET_SERVICES_SUCCESS,
  payload: services,
})

export const getServicesFail = error => ({
  type: GET_SERVICES_FAIL,
  payload: error,
})

export const getNotificationChannel = () => ({
  type: GET_NOTIFICATION_CHANNEL,
})

export const getNotificationChannelSuccess = notification_channel => ({
  type: GET_NOTIFICATION_CHANNEL_SUCCESS,
  payload: notification_channel,
})

export const getNotificationChannelFail = error => ({
  type: GET_NOTIFICATION_CHANNEL_FAIL,
  payload: error,
})

export const getPagerDutyServices = () => ({
  type: GET_PAGERDUTY_SERVICES,
})

export const getPagerDutyServicesSuccess = pagerduty_services => ({
  type: GET_PAGERDUTY_SERVICES_SUCCESS,
  payload: pagerduty_services,
})

export const getPagerDutyServicesFail = error => ({
  type: GET_PAGERDUTY_SERVICES_FAIL,
  payload: error,
})

export const getOpsGenieServices = () => ({
  type: GET_OPSGENIE_SERVICES,
})

export const getOpsGenieServicesSuccess = opsgenie_services => ({
  type: GET_OPSGENIE_SERVICES_SUCCESS,
  payload: opsgenie_services,
})

export const getOpsGenieServicesFail = error => ({
  type: GET_OPSGENIE_SERVICES_FAIL,
  payload: error,
})

export const getSpecificServices = data => ({
  type: GET_SPECIFIC_SERVICES,
  payload: data
})

export const getSpecificServicesSuccess = specific_services => ({
  type: GET_SPECIFIC_SERVICES_SUCCESS,
  payload: specific_services,
})

export const getSpecificServicesFail = error => ({
  type: GET_SPECIFIC_SERVICES_FAIL,
  payload: error,
})

export const createOrUpdateTag = data => ({
  type: CREATE_UPDATE_TAG,
  payload: data
});

export const createOrUpdateTagSuccess = response => ({
  type: CREATE_UPDATE_TAG_SUCCESS,
  payload: response
});

export const createOrUpdateTagFail = error => ({
  type: CREATE_UPDATE_TAG_FAIL,
  payload: error
});

export const fetchTagValuesByService = serviceId => ({
  type: GET_TAG_VALUES,
  payload: {serviceId}
});

export const fetchTagValuesByServiceSuccess = tagValues => ({
  type: GET_TAG_VALUES_SUCCESS,
  payload: tagValues
});

export const fetchTagValuesByServiceFail = error => ({
  type: GET_TAG_VALUES_FAIL,
  payload: error
});

export const deleteTagValue = data => ({
  type: DELETE_TAG_VALUE,
  payload: data
});

export const deleteTagValueSuccess = response => ({
  type: DELETE_TAG_VALUE_SUCCESS,
  payload: response
});

export const deleteTagValueFail = error => ({
  type: DELETE_TAG_VALUE_FAIL,
  payload: error
});

export const fetchAllKeyNames = () => ({
  type: GET_ALL_KEY_NAMES
});

export const fetchAllKeyNamesSuccess = keys => ({
  type: GET_ALL_KEY_NAMES_SUCCESS,
  payload: keys
});

export const fetchAllKeyNamesFail = error => ({
  type: GET_ALL_KEY_NAMES_FAIL,
  payload: error
});

export const getIntegrationKeys = (application_service_id) => ({
  type: GET_INTEGRATION_KEYS,
  payload: { application_service_id }
})

export const getIntegrationKeysSuccess = integration_keys => ({
  type: GET_INTEGRATION_KEYS_SUCCESS,
  payload: integration_keys,
})

export const getIntegrationKeysFail = error => ({
  type: GET_INTEGRATION_KEYS_FAIL,
  payload: error,
})

export const getIntegrationActionURL = (integration_key_id) => ({
  type: GET_INTEGRATION_ACTION_URL,
  payload: { integration_key_id }
})

export const getIntegrationActionURLSuccess = integration_action_url => ({
  type: GET_INTEGRATION_ACTION_URL_SUCCESS,
  payload: integration_action_url,
})

export const getIntegrationActionURLFail = error => ({
  type: GET_INTEGRATION_ACTION_URL_FAIL,
  payload: error,
})

export const getRedirectSlack = () => ({
  type: GET_REDIRECT_SLACK,
})

export const getRedirectSlackSuccess = services => ({
  type: GET_REDIRECT_SLACK_SUCCESS,
  payload: services,
})

export const getRedirectSlackFail = error => ({
  type: GET_REDIRECT_SLACK_FAIL,
  payload: error,
})

export const postService = (service, history) => {
  return {
    type: POST_SERVICE,
    payload: { service, history }
  }
}

export const postServiceSuccess = services => ({
  type: POST_SERVICE_SUCCESS,
  payload: services,
})

export const postServiceFail = error => ({
  type: POST_SERVICE_FAIL,
  payload: error,
})
export const postUpdateService = (service) => {
  return {
    type: POST_UPDATE_SERVICE,
    payload: { service }
  }
}

export const postUpdateServiceSuccess = service => ({
  type: POST_UPDATE_SERVICE_SUCCESS,
  payload: service,
})

export const postUpdateServiceFail = error => ({
  type: POST_UPDATE_SERVICE_FAIL,
  payload: error,
})

export const postResendServiceEmailSuccess = data => {
  return {
    type: POST_RESEND_SERVICE_EMAIL_VERIFICATION_SUCCESS,
    payload: data
  }
}


export const postResendServiceEmailFail = error => {
  return {
    type: POST_RESEND_SERVICE_EMAIL_VERIFICATION_FAIL,
    payload: error
  }
}


export const postCreateIntegrationKey = (application_service_id, integration_name, integration_type) => {
  return {
    type: POST_CREATE_INTEGRATION_KEY,
    payload: { application_service_id, integration_name, integration_type }
  }
}

export const postCreateIntegrationKeySuccess = response => ({
  type: POST_CREATE_INTEGRATION_KEY_SUCCESS,
  payload: response,
})

export const postCreateIntegrationKeyFail = error => ({
  type: POST_CREATE_INTEGRATION_KEY_FAIL,
  payload: error,
})

export const resetIntegrationUrl = () => ({
  type: RESET_INTEGRATION_URL,
});

export const postTestNotification = data => ({
  type: POST_TEST_NOTIFICATION,
  payload: data,
})

export const postTestNotificationSuccess = data => ({
  type: POST_TEST_NOTIFICATION_SUCCESS,
  payload: data,
})

export const postTestNotificationFail = error => ({
  type: POST_TEST_NOTIFICATION_FAIL,
  payload: error,
})


export const getBluejayMasterCommunicationChannels = () => ({
  type: GET_MASTER_BLUEJAY_COMMUNICATION_CHANNEL,
})

export const getBluejayMasterCommunicationChannelsSuccess = channels => ({
  type: GET_MASTER_BLUEJAY_COMMUNICATION_CHANNEL_SUCCESS,
  payload: channels,
})

export const getBluejayMasterCommunicationChannelsFail = error => ({
  type: GET_MASTER_BLUEJAY_COMMUNICATION_CHANNEL_FAIL,
  payload: error,
})


export const getBluejayCommunicationChannelByServiceId = (data) => ({
  type:GET_BLUEJAY_COMMUNICATION_CHANNEL_BY_SERVICE_ID,
  payload: data,
})

export const getBluejayCommunicationChannelByServiceIdSuccess = data => ({
  type:GET_BLUEJAY_COMMUNICATION_CHANNEL_BY_SERVICE_ID_SUCCESS,
  payload: data,
})

export const getBluejayCommunicationChannelByServiceIdFail = error => ({
  type:GET_BLUEJAY_COMMUNICATION_CHANNEL_BY_SERVICE_ID_FAIL,
  payload: error,
})

export const postBluejayCommunicationChannelByServiceId = (data) => ({
  type:POST_UPDATE_BLUEJAY_COMMUNICATION_CHANNEL_BY_ID,
  payload: data
})

export const postBluejayCommunicationChannelByServiceIdSuccess = data => ({
  type:POST_UPDATE_BLUEJAY_COMMUNICATION_CHANNEL_BY_ID_SUCCESS,
  payload:data
})

export const postBluejayCommunicationChannelByServiceIdFail = error => ({
  type:POST_UPDATE_BLUEJAY_COMMUNICATION_CHANNEL_BY_ID_FAIL,
  payload: error,
})

export const postSetMaintenanceByServiceID = (data) => ({
  type: SET_MAINTENANCE_WINDOW_BY_ID,
  payload: data
})

export const postSetMaintenanceByServiceIdSuccess = (data) => ({
  type: SET_MAINTENANCE_WINDOW_BY_ID_SUCCESS,
  payload: data
})

export const postSetMaintenanceByServiceIdFail = (error) => ({
  type: SET_MAINTENANCE_WINDOW_BY_ID_FAIL,
  payload: error,
})